import React, { useState, useEffect, useRef } from "react";
import { TextField, IconButton } from "@material-ui/core";
import { Send as SendIcon } from "@material-ui/icons";
import PlayerAvatar from "./PlayerAvatar";
import "../../styling/lobby-chat.css";

const LobbyChat = ({ socket, room, name, playerColors, playerEmojis, messages = [] }) => {
  const [inputMessage, setInputMessage] = useState("");
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!inputMessage.trim() || !socket?.current) return;

    socket.current.emit("lobby_chat_message", {
      room,
      name,
      message: inputMessage.trim()
    });

    setInputMessage("");
  };

  return (
    <div className="lobby-chat-container">
      <div className="lobby-chat-messages" ref={chatContainerRef}>
        {messages.length === 0 ? (
          <div className="lobby-chat-empty">
            <p>No messages yet. Start the conversation!</p>
          </div>
        ) : (
          messages.map((msg, index) => (
            <div
              key={index}
              className={`lobby-chat-message ${
                msg.name === name ? "lobby-chat-message-own" : ""
              }`}
            >
              <div className="lobby-chat-message-avatar">
                <PlayerAvatar
                  playerName={msg.name}
                  playerColor={playerColors[msg.name]}
                  playerEmoji={playerEmojis[msg.name]}
                  size="small"
                  showLabel={false}
                />
              </div>
              <div className="lobby-chat-message-content">
                <div className="lobby-chat-message-header">
                  <span className="lobby-chat-message-name">{msg.name}</span>
                  <span className="lobby-chat-message-time">
                    {msg.timestamp
                      ? new Date(msg.timestamp).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit"
                        })
                      : ""}
                  </span>
                </div>
                <div className="lobby-chat-message-text">{msg.message}</div>
              </div>
            </div>
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
      <form className="lobby-chat-input-form" onSubmit={handleSendMessage}>
        <TextField
          fullWidth
          placeholder="Type a message..."
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          variant="outlined"
          size="small"
          className="lobby-chat-input"
          disabled={!socket?.current}
        />
        <IconButton
          type="submit"
          color="primary"
          disabled={!inputMessage.trim() || !socket?.current}
          className="lobby-chat-send-button"
        >
          <SendIcon />
        </IconButton>
      </form>
    </div>
  );
};

export default LobbyChat;

